import React, { useMemo } from "react";

import { AppNotification } from "@pma/types";
import NotificationCard from "./notification-card";
import PmsLoader from "@components/common/loader";
import { Button } from "@components/common/button";

import { AlertCircle } from "lucide-react";
import useTranslator from "@hooks/use-translator";

interface NotificationListProps {
  data: any;
  onNotificationClick: () => void;
  loadMore?: CallableFunction;

  context: "all" | "unread" | "mentioned" | "assigned" | "logs";
  isLoading?: boolean;
}

export const NotificationList: React.FC<NotificationListProps> = ({
  data,
  onNotificationClick,
  loadMore,

  context = "all",
  isLoading = false,
}) => {
  const { translate } = useTranslator();

  if (isLoading) {
    return (
      <>
        {isLoading && (
          <div
            style={{
              width: "100%",
              marginBlock: "10px",
            }}
          >
            <PmsLoader />
          </div>
        )}
      </>
    );
  }
  return (
    <div className="flex flex-col gap-2 overflow-y-auto overflow-x-hidden h-[80vh]">
      {data &&
        data?.pages?.map((page: any) =>
          page?.items?.map((notification: AppNotification, index: number) => (
            <NotificationCard
              notification={notification}
              context={context}
              onNotificationClick={onNotificationClick}
              key={index}
            />
          )),
        )}
      {!data?.pages[0]?.pageTotal && (
        <div className="h-[90vh] flex flex-col items-center justify-center text-2xl border border-slate-300 rounded-md">
          {translate("No items found")}
          <AlertCircle size={40} className="mt-2" />
        </div>
      )}
      {loadMore && (
        <Button
          variant={"link"}
          loading={isLoading}
          className="w-full m-2"
          onClick={() => loadMore && loadMore(context)}
        >
          {translate("Load More")}
        </Button>
      )}
    </div>
  );
};

export default NotificationList;
